import { Grid, Pagination } from "@mui/material";
import { LocaleContext } from "../../../routing/LangRouter";
import { useContext } from "react";

function BasePagination({ count, page, handleChange }) {
    const { locale } = useContext(LocaleContext);
    return (
        <Grid container item xs={12} justifyContent="center" my={1}>
            <Pagination
                // dir="ltr"
                count={count}
                page={page ?? 1}
                onChange={handleChange}
                color="primary"
                sx={{
                    "& .MuiPagination-ul": {
                        "& li": {
                            "& .Mui-selected": {
                                color: "#006363",
                                background: "white",
                                boxShadow: "0px 0px 8px #006363",
                            },
                            "& button": {
                                "& svg": {
                                    transform: `${locale === "en" ? "scaleX(-1)" : ""} `,
                                },
                            },
                        },
                    },
                }}
            />
        </Grid>
    );
}

export default BasePagination;
